export default __webpack_public_path__ + "static/media/img1.4bd1278b.jpeg";